import React, { useEffect } from "react";
import { ResponseError } from "../../resources/ResponseError";
import { loginCT } from "./constants/login.constants";

import { LoginView_ah } from "./view";
import {
  LoadingAFY,
  onSignInDTO,
  typeAlert,
  typeLoaders
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { themeCore } from "../../assets/themes/theme";
import { useAuth } from "../../authContext";
import { useNavigate } from "react-router-dom";
import LocalStorageService from "../../services/localStorage";
import { GetMenuHeader, GetMenuSideBarHome } from "../../services/nav";
import showToast from "../../services/toast";
import { getCustomerAction } from "../../fnx/customer";
import { useDispatch, useSelector } from "react-redux";
import i18Next from "i18next";
import { useTranslation } from "react-i18next";
import {
  loginUser,
  loginUserClearData,
  userConfirmEmailClearData,
  userConfirmPasswordClearData,
  userPasswordResetClearData
} from "../../store/auth/actions";
import { showErrorToast } from "../../fnx/showError";
import { byPassLogin, handleMicrosoftLogin, postSSOValidation } from "../../../src/resources/helper/login";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";

const Login = () => {
  const [isFalseSSO, setIsFalseSSO] = React.useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { status, setStatus } = useAuth();
  const storageKey = "afy-login";
  const [loading, setLoading] = React.useState(false);
  const localStorageService = new LocalStorageService(storageKey);
  const { t } = useTranslation();

  const [seeToast, setSeeToast] = React.useState<{
    show: boolean;
    type: typeAlert;
    message: string;
  }>({
    show: false,
    message: "",
    type: typeAlert.success,
  });

  const { responseLogin, errorLogin, loadingLogin } = useSelector(
    (state: any) => ({
      responseLogin: state.Login.responseLogin,
      errorLogin: state.Login.errorLogin,
      loadingLogin: state.Login.loadingLogin,
    }),
  );

  const onLoginSSO = async () => {
    handleMicrosoftLogin("");
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const clientId = params.get("clientId");

    if (token && clientId) {
      console.log("Token: ", token);
      console.log("ClientId: ", clientId);
      byPassLogin(token, clientId).then((response) => {
        console.log("Response: ", response);
        handleLogin(response, token, true);
      });
    } else {
      setIsFalseSSO(false);
      const msiAccessToken = localStorage.getItem("msi_access_token");
      if (msiAccessToken) {
        setLoading(true);
        postSSOValidation(msiAccessToken).then((response) => {
          setLoading(false);
          if (response) {
            handleLogin(response, response.accessToken.jwtToken, true);
          } else {
            setSeeToast({
              show: true,
              type: typeAlert.error,
              message: t("Error al iniciar sesión"),
            });
            console.log("Error: No response from postSSOValidation");
          }
        });
      } else {
        console.log("No MSI Access Token found in localStorage");
      }
    }
  }, []);

  const handleLogin = (response: any, token: any, isBypass = false) => {
    console.log("****isBypass****", isBypass);
    setIsFalseSSO(isBypass);

    try {
      const storageKeyMh = "afy-menuh";
      const storageKeyMs = "afy-menus";
      const lsMH = new LocalStorageService(storageKeyMh);
      const lsMS = new LocalStorageService(storageKeyMs);
      let userDetails: any = {
        token: token,
        userName: response.user.name,
        email: response.user.email,
        clientId: response.client.id,
        countryId: response.client.countryId,
        branchId: response.branch.id,
        userId: response.user.id,
        subdomain: response.client.subdomain,
        roles: response.user.roles,
      };

      if (!isBypass) {
        userDetails.idToken = {
          jwtToken: response.accessToken.jwtToken,
          payload: {
            name: response.idToken?.payload?.name ?? response.user.name,
            family_name:
              response.idToken?.payload?.family_name ?? response.user.lastName,
          },
        };
      } else {
        userDetails.idToken = {
          jwtToken: token,
          payload: {
            name: response.user.name,
            family_name: response.user.family_name,
          },
        };
      }
      localStorageService.setUserLoginStored(userDetails);

      if (
        getCustomerAction().customerAuto.includes(response.client.subdomain)
      ) {
        localStorage.setItem("i18nextLng", "es");
        localStorage.setItem("i18nextDefaultNamespace", "apapauto");

        i18Next.loadNamespaces("apapauto", () => {
          i18Next.setDefaultNamespace("apapauto");
          i18Next.changeLanguage("es");
        });
      } else {
        localStorage.setItem("i18nextLng", "es");
        localStorage.setItem("i18nextDefaultNamespace", "default");

        i18Next.loadNamespaces("default", () => {
          i18Next.setDefaultNamespace("default");
          i18Next.changeLanguage("es");
        });
      }

      lsMH.setMenuHorizontalStored(GetMenuHeader());
      lsMS.setMenuSideBarStored(GetMenuSideBarHome());

      setStatus("authenticated");
    } catch (error) {
      console.log("Error on login: ", error);
    }
  };

  useEffect(() => {
    if (responseLogin) {
      handleLogin(responseLogin, status, false);
    }
  }, [responseLogin]);

  useEffect(() => {
    if (errorLogin) {
      const error = errorLogin as ResponseError;
      let message;

      showErrorToast(errorLogin?.response, setSeeToast, t);

      if (error.response?.errors !== undefined) {
        let key = `login.errors.${error.response.errors[0]?.message}`;
        message = t(key);
      } else {
        console.log("Error: ", error.response?.message);
        message = t("error");
      }
      if (error) {
        if (error.response?.errors[0]?.message === "USER_NOT_CONFIRMED") {
          dispatch(loginUserClearData());
          dispatch(userConfirmEmailClearData());
          navigate("/confirmEmail");
        }
      }
    }
  }, [errorLogin]);

  const onClickForgetPassword = () => {
    dispatch(userPasswordResetClearData());
    dispatch(userConfirmPasswordClearData());
    navigate("/passwordReset");
  };

  const lgSingIn = (form: onSignInDTO) => {
    const storageKeyMh = "afy-menuh";
    const storageKeyMs = "afy-menus";
    const lsMH = new LocalStorageService(storageKeyMh);
    const lsMS = new LocalStorageService(storageKeyMs);

    /*    lsMH.setMenuHorizontalStored([]);
    lsMS.setMenuSideBarStored(GetMenuSideBarHome());
    lsMS.setMenuSideBarStored(GetMenuSideBarAdministration());
       */

    dispatch(
      loginUser({
        userName: form.email,
        password: form.password,
      }),
    );
  };

  return (
    <React.Fragment>
      <AlertLoadingHeader
        loading={loadingLogin}
        seeToast={seeToast}
        showToast={showToast}
        setSeeToast={setSeeToast}
        titleLoading={t("login.loadingLogin")}
      />
      {loading && (
        <LoadingAFY
          loading={loading}
          backgroundColor={themeCore.colors.backgroundLoader}
          typeAnimation={typeLoaders.LogoAfy}
          sizeAnimation={65}
          textLoading={t("login.loadingLogin")}
          textLoadingColor={themeCore.colors.third}
          spinnerColor={themeCore.colors.third}
        />
      )}
      {!isFalseSSO ? (
        <LoginView_ah
          {...loginCT}
          onSignIn={(form: onSignInDTO) => {
            lgSingIn(form);
            return form;
          }}
          onSubmitSSO={(data: any) => {
            handleMicrosoftLogin(data);
          }}
        />
      ) : (
        <LoadingAFY
          loading={!loadingLogin}
          backgroundColor={themeCore.colors.backgroundLoader}
          typeAnimation={typeLoaders.LogoAfy}
          sizeAnimation={65}
          textLoading={t("login.loadingLogin")}
          textLoadingColor={themeCore.colors.third}
          spinnerColor={themeCore.colors.third}
        />
      )}
    </React.Fragment>
  );
};
export default Login;
